/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Appointment } from './Appointment'
import type { BusinessIntelligenceBiReportingComponent } from './BusinessIntelligenceBiReportingComponent'
import type { Candidate } from './Candidate'
import type { Company } from './Company'
import type { GlobalAddressComponent } from './GlobalAddressComponent'
import type { Interaction } from './Interaction'
import type { Message } from './Message'
import type { Placement } from './Placement'
import type { ProfessionalAboutComponent } from './ProfessionalAboutComponent'
import type { ProfessionalExperienceComponent } from './ProfessionalExperienceComponent'
import type { ProfessionalUpdateEmailComponent } from './ProfessionalUpdateEmailComponent'
import type { ProfilingFilterTagComponent } from './ProfilingFilterTagComponent'
import type { Referral } from './Referral'
import type { Tag } from './Tag'
import type { Talentpool } from './Talentpool'
import type { Users_Permissions_User } from './Users_Permissions_User'
export type Professional = {
  id?: number
  status: Professional.status
  address?: GlobalAddressComponent
  about?: ProfessionalAboutComponent
  experiences?: Array<ProfessionalExperienceComponent>
  tags?: Array<Tag>
  interests?: Array<Company>
  user?: Users_Permissions_User
  maximumRadiusKm?: number
  interactions?: Array<Interaction>
  lastUpdateEmail?: ProfessionalUpdateEmailComponent
  appointments?: Array<Appointment>
  placements?: Array<Placement>
  candidate?: Candidate
  filterTags?: Array<ProfilingFilterTagComponent>
  biNotes?: string
  finishedOnboarding?: boolean
  businessIntelligence?: BusinessIntelligenceBiReportingComponent
  messages?: Array<Message>
  talentpools?: Array<Talentpool>
  referredBy?: Array<Referral>
  sentReferrals?: Array<Referral>
  currentJobTitle?: string
  searchSimilar?: boolean
  autoInteract?: boolean
  origin?: Professional.origin
  createdAt?: string
  updatedAt?: string
  createdBy?: Users_Permissions_User
  updatedBy?: Users_Permissions_User
}
export namespace Professional {
  export enum status {
    ORIENTATING = 'orientating',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
  }
  export enum origin {
    SOCIAL_MEDIA_INSTAGRAM_AD = 'social_media_instagram_ad',
    SOCIAL_MEDIA_POST = 'social_media_post',
    VIA_FRIENDS_OR_FAMILY = 'via_friends_or_family',
    APPROACHED_BY_HEYU = 'approached_by_heyu',
    REFERRED_COMPANY = 'referred_company',
    GOOGLE_SEARCH = 'google_search',
    AI_SEARCH = 'ai_search',
    DONT_REMEMBER = 'dont_remember',
  }
}
